import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Breadcrumb } from '../ui/Breadcrumb';

export const Layout = ({ 
  children, 
  showFooter = true, 
  hideLogo = false,
  breadcrumbItems = null,
  pageTitle = null,
  showBreadcrumb = true
}) => {
  return (
    <div className="min-h-screen bg-navigate-dark flex flex-col noise-overlay overflow-x-hidden">
      <Header hideLogo={hideLogo} />
      <main className="flex-1 overflow-x-hidden">
        {showBreadcrumb && (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4">
            <Breadcrumb items={breadcrumbItems} pageTitle={pageTitle} />
          </div>
        )}
        {children}
      </main>
      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
